import * as colors from 'src/assets/styles/custom/variables.module.scss';

export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

type TThemeColors = {
  dark: string;
  //
  white: string;
  white60: string;
  //
  mainblue: string; // primary
  blue2: string;
  blue3: string;
  bluelight: string;
  //
  gray: string;
  gray2: string;
  gray3: string;
  gray4: string;
  graysoft: string;
  graylight: string;
  graysection: string;
  //
  red: string;
  red2: string;
  red3: string;
  redrich: string;
  redlight: string;
  //
  green: string;
  greenlight: string;
  //
  orange: string;
  //
  yellow: string;
  yellowlight: string;
  //
  chart: string;
  subscribe: string;
  transparent: string;
};

export enum COLORS {
  DARK = 'dark',
  //
  WHITE = 'white',
  WHITE60 = 'white60',
  //
  MAINBLUE = 'mainblue', // primary
  BLUE2 = 'blue2',
  BLUE3 = 'blue3',
  BLUELIGHT = 'bluelight',
  //
  GRAY = 'gray',
  GRAY2 = 'gray2',
  GRAY3 = 'gray3',
  GRAY4 = 'gray4',
  GRAYSOFT = 'graysoft',
  GRAYLIGHT = 'graylight',
  GRAYSECTION = 'graysection',
  //
  RED = 'red',
  RED2 = 'red2',
  RED3 = 'red3',
  REDRICH = 'redrich',
  REDLIGHT = 'redlight',
  //
  GREEN = 'green',
  GREENLIGHT = 'greenlight',
  //
  ORANGE = 'orange',
  //
  YELLOW = 'yellow',
  YELLOWLIGHT = 'yellowlight',
  //
  CHART = 'chart',
  SUBSCRIBE = 'subscribe',
  TRANSPARENT = 'transparent',
}

type TTheme = {
  colors: TThemeColors;
};
const theme: TTheme = { colors: colors.default as TThemeColors };

export enum FONT_FAMILY {
  MEDIUM = 'medium',
  REGULAR = 'regular',
  SEMIBOLD = 'semibold',
  BOLD = 'bold',
}

export const PALETTE_COLORS: string[] = [
  '#00A1D8',
  '#0061FD',
  '#4D22B2',
  '#982ABC',
  '#B92D5D',
  '#FF4015',
  '#FF6A00',
  '#FFAB01',
  '#FCC700',
  '#FEFB41',
  '#D9EC37',
  '#76BB40',
];
// this color is set by backend for zone, if her branch will deleted
export const ZONE_UNAVAILABLE_COLOR: string = '#808080';

export const topListColors: Record<number, string> = {
  1: '#A168FF',
  2: '#6891F9',
  3: '#82D7C2',
  4: '#8AB9FF',
  5: '#F9CD5B',
  6: '#FC6BFF',
  7: '#FE8080',
  8: '#58E566',
  9: '#FFA724',
  10: '#FC79C8',
  11: '#510102',
  12: '#429EFF',
  13: '#FFD130',
};

export const dropdownOptionHeight = 53;
export const dropdownSmallOptionHeight = 38;
export const dropdownWithoutOptionsMinHeight = 100;
export const dropdownMaxOptions = 8;

export default theme;
